import {Component, OnInit} from '@angular/core';
// @ts-ignore
import reviewList from '../../../../../assets/reviews/review-list.json';
import {
  Photo,
  PhotoGallerySettings
} from "../../../widgets/fancy-photo-gallery/fancy-photo-gallery/fancy-photo-classes";
import {getFancyboxHeightCLS} from '../../../../../helpers';

@Component({
  selector: 'app-climb-reviews',
  templateUrl: './climb-reviews.component.html',
  styleUrls: ['./climb-reviews.component.css']
})
export class ClimbReviewsComponent implements OnInit {
  getFancyboxHeightCLS = getFancyboxHeightCLS;
  reviewsPerPage = 5;
  pageNum = 1;
  reviewList = reviewList.reviews; // ALL reviews
  pageOfReviews: Array<any>; // per page set of reviews
  photoGalleries = [];

  constructor() {
  }

  ngOnInit() {
    this.onChangeReviewPage({content: this.reviewList.slice(0, 5), page: 1});
    this.filterPhotos();
  }

  onChangeReviewPage(newPage: any) {
      // update current page of items
      this.pageOfReviews = newPage.content;
      this.pageNum = newPage.page - 1;
  }

  filterPhotos() {
    for (const review of this.reviewList) {
      const reviewPhotoArray = this.constructPhotoArray(review);
      const reviewGallerySettings = new PhotoGallerySettings({
        iconColor: 'dark',
        photos: reviewPhotoArray
      });
      this.photoGalleries.push(reviewGallerySettings);
    }
  }

  constructPhotoArray(review: any) {
    const photoArray = [];
    if (review.photos.length > 0) {
      for (const photo of review.photos) {
        photoArray.push(
          new Photo({
            title: photo.photoTitle,
            description: photo.photoDescription,
            thumbnailPath: photo.photoThumbRoute,
            highresPath: photo.photoRoute,
            altPhotoDescription: photo.photoDescription
          })
        );
      }
      return photoArray;
    } else {
      return [];
    }
  }

  printTimeSince(interval: number, unit: string) {
    const num = Math.floor(interval);
    return num + " " + unit + (num <= 1 ? "" : "s");
  }

  timeSince(date: Date) {
    const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
    let interval = seconds / 31536000;
    if (interval > 1) {
      return this.printTimeSince(interval, "year");
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return this.printTimeSince(interval, "month");
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return this.printTimeSince(interval, "day");
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return this.printTimeSince(interval, "hour");
    }
    interval = seconds / 60;
    if (interval > 1) {
      return this.printTimeSince(interval, "minute");
    }
    return this.printTimeSince(interval, "second");
  }

  determineReviewTime(review: any) {
    const reviewDate = new Date(review.datePublished);
    return this.timeSince(reviewDate) + " ago";
  }

}
